import classNames from 'classnames'
import DropArrow from 'components/assets/icons/DropArrow'
import { useState, useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import style from './Collapsible.module.scss'

const Collapsible = ({ className, content, isArrowReversed, isOpenedProp, onToggle, title, price, hideArrow }) => {
  const [isOpened, setIsOpened] = useState(isOpenedProp)
  const { color, colabelNeutralLight, colabelNeutralDark } = useContext(ClientContext)

  const toggleContent = () => {
    onToggle ? onToggle() : setIsOpened(!isOpened)
  }

  return (
    <div className={classNames(style.collapsible, className)} style={color && {background: colabelNeutralLight}}>
      <div className={style.top} onClick={toggleContent}>
        <div
          className={classNames(
            style.arrow,
            ((isOpened && !isArrowReversed) || (!isOpened && isArrowReversed)) && style.up,
          )}
        >
          {!hideArrow && <DropArrow styles={color && {stroke: colabelNeutralDark}} />}
        </div>
        <h4 className={style.title} style={color && {color: colabelNeutralDark}}>{title}</h4>
        {price && <span>{price}</span>}
      </div>
      <div
        className={classNames(style.content, isOpened && style.opened)} style={color && {color: colabelNeutralDark}}>{content}</div>
    </div>
  )
}

export default Collapsible
